module.exports = __webpack_public_path__ + "static/img/banner1.2a96033.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner1.png
// module id = Hs6o
// module chunks = 0